import clsx from 'clsx';
import React from 'react';

import mergeClasses from '../../../utils/shallowMerge';
import defaultClasses from './TextLink.module.scss';

// use Link and NavLink
export const TextLink = React.forwardRef(
  (
    {
      underline,
      align,
      children,
      className,
      onClick,
      href,
      role,
      uppercase,
      newClasses,
      dataAttributes,
    },
    ref,
  ) => {
    const styles = mergeClasses(defaultClasses, newClasses);

    const customClasses = clsx(
      styles.textLink,
      styles[align],
      {
        [` ${styles.underlineHover}`]: underline === 'hover',
        [` ${styles.underlineAlways}`]: underline === 'always',
        [` ${styles.underlineVisible}`]: underline === 'visible',
        [` ${styles.uppercase}`]: uppercase,
      },
      className,
    );
    return (
      <a
        ref={ref}
        onClick={onClick}
        href={href}
        role={role}
        className={customClasses}
        {...dataAttributes}
      >
        <span className={styles.label}>{children}</span>
        {/* <span className={styles.shadow} /> */}
      </a>
    );
  },
);
